import { SubscriptionWithGetIT, SubscriptionWithMBB } from "../../../../../../models";

export const viaplayPriceDiscount = 100;

export const getSubscriptionTitles = (
    normalPrice: number,
    discountedPrice: number,
    subscription: SubscriptionWithGetIT | SubscriptionWithMBB,
    showFamilyDiscount: boolean,
    showCommitment: boolean,
    priceInfo?: string[],
    isPDP?: boolean,
    showGroupedCard?: boolean,
): {
    name?: string;
    price: number | string;
    priceInfoInner?: string[];
    priceStriketrough: number | string;
    priceSuffix?: string;
    striketroughTitle?: string;
    title: string;
    isTeliaTrygg: boolean;
    tsTitle?: string;
} => {
    let name;
    let title;
    let striketroughTitle;
    let tsTitle;
    let priceSuffix;
    let priceInfoInner = priceInfo;
    let isTeliaTrygg = false;
    let price: number | string = normalPrice !== discountedPrice ? discountedPrice : normalPrice;
    let priceStriketrough: number | string = normalPrice !== discountedPrice ? normalPrice : "";

    price =
        showFamilyDiscount && !subscription.isTryBuySubscription
            ? (subscription.monthlyPriceLines || 0) * (subscription.priceMultiplier || 1) -
              (subscription.firstYearDiscountAmount || 0)
            : subscription.monthlyPrice * (subscription.priceMultiplier || 1) -
              (subscription.monthlyDiscount ?? 0) -
              (subscription.firstYearDiscountAmount || 0);
    priceStriketrough = price < subscription.monthlyPrice ? subscription.monthlyPrice : "";

    if (showCommitment && ["TELIA_MOBIL_X_RASK_VT", "TELIA_MOBIL_X_RASK_VT_2026"].includes(subscription.offeringCode)) {
        price -= viaplayPriceDiscount;
    }

    price = Math.ceil(price);

    if (subscription.billingType === "prepaid") {
        price = subscription.upfrontPrice || "";
        priceStriketrough = "";
        title = subscription.subscriptionShortname || "";
        priceInfoInner = [];
    } else if (subscription.isTryBuySubscription) {
        title = isPDP ? "Ubegrenset data" : `${subscription.subscriptionShortname}`;
        name = isPDP ? `${subscription.subscriptionShortname}` : "Ubegrenset data";
        priceStriketrough = "";
        priceSuffix = "i 2 måneder";
    } else if (subscription.dataUnlimited) {
        const originalSpeedTitle =
            `${subscription.dataMaxSpeed?.amount || ""} ${subscription.dataMaxSpeed?.unit || ""}`.trim();
        const doubleSpeedTitle = `${subscription.doubleSpeed || ""} ${subscription.dataMaxSpeed?.unit || ""}`.trim();
        title = "Ubegrenset data";
        const listingName =
            [
                "TELIA_MOBIL_X_RASK_VT",
                "TELIA_MOBIL_X_RASK_VT_2026",
                "TELIA_MOBIL_X_UNG_2025_2",
                "TELIA_MOBIL_X_UNG_2026",
            ].includes(subscription.offeringCode) || !showGroupedCard
                ? subscription.subscriptionShortname
                : "Velg hastighet opptil 1000 Mbit/s";
        name = isPDP ? `${subscription.subscriptionShortname}` : listingName;
        striketroughTitle = subscription.doubleSpeed && !isPDP ? originalSpeedTitle : "";
        tsTitle = subscription.doubleSpeed ? doubleSpeedTitle : "";
    } else if (subscription.isBarnSubscription) {
        name = subscription.offeringCode === "TELIA_JUNIOR_KLOKKE_01GB" ? "Barneklokke-abonnement" : "Junior";
        const originalTitle = `${subscription.dataIncluded?.amount} ${subscription.dataIncluded?.unit}`;
        title = subscription.doubleData
            ? `${subscription.doubleData} ${subscription.dataIncluded?.unit}`
            : originalTitle;
        tsTitle = title;
        striketroughTitle = subscription.doubleData ? originalTitle : "";
    } else {
        const originalTitle = `${subscription.dataIncluded?.amount} ${subscription.dataIncluded?.unit}`;
        title = originalTitle;
        if (subscription.doubleData) {
            title = `${subscription.doubleData} ${subscription.dataIncluded?.unit}`;
        }
        if (subscription.doubleSpeed) {
            title = `${subscription.doubleSpeed} ${subscription.dataMaxSpeed?.unit}`;
        }

        tsTitle = title;
        striketroughTitle = subscription.doubleData ? originalTitle : "";
    }

    if (subscription.overrideSubscriptionTitle) {
        title = subscription.overrideSubscriptionTitle;
        tsTitle = subscription.overrideSubscriptionTitle;
        striketroughTitle = "";
    }

    if (["TRYGG_B2C_INDIVIDUAL", "TRYGG_B2C_FAMILY"].includes(subscription.offeringCode)) {
        isTeliaTrygg = true;
        name = subscription.subscriptionShortname || "";
        title = subscription.offeringCode.includes("TRYGG_B2C_FAMILY")
            ? "Digital trygghet for hele familien – beskyttelse, varsler og forsikringer"
            : "Digital trygghet for deg og enhetene dine – beskyttelse, varsler og forsikringer";
        priceSuffix = `Deretter ${subscription.monthlyPrice},- pr. md.`;
        price = "Prøv gratis i 3 måneder";
    }

    if (isPDP) {
        if (!name) {
            name = title;
            title = "";
        }
    }

    return {
        name,
        title,
        striketroughTitle,
        tsTitle,
        priceInfoInner,
        price,
        priceStriketrough,
        priceSuffix,
        isTeliaTrygg,
    };
};
